<template>
    <div class="accordion-item">
        <h3 class="accordion-header" id="area-header">
            <button class="accordion-button d-flex" type="button" data-bs-toggle="collapse" data-bs-target="#area-collapse" aria-expanded="true" aria-controls="area-collapse">
                <span class="flex-grow-1">Areas</span>
                <span class="badge rounded-pill bg-primary me-2">{{ selected.length }}</span>
            </button>
        </h3>
        <div id="area-collapse" class="accordion-collapse collapse" aria-labelledby="area-header" data-bs-parent="#accordion-filter-options" ref="accbody">
            <div class="accordion-body">
                <multiselect
                    v-model="selected"
                    :options="areas"
                    :multiple="true"
                    :customLabel="getLabel"
                    placeholder="Select areas"
                    track-by="id"
                    @input="store"
                ></multiselect>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import VueCookies from 'vue-cookies';

export default {
    components: { Multiselect, VueCookies },

    props: {
        gradeLevels: {
            type: Array,
            default: [],
        }
    },

    mounted() {
        this.load();
    },

    watch: {
        gradeLevels: function(n, o) {
            this.load();
        }
    },

    methods: {
        load: function() {
            const grade_levels = this.$parent.$refs.gradeLevelSelect.selected.flatMap( a => a.grade ?? 0);
            this.$parent.isLoading = true;
            axios
                .get(`/api/areas?grade_levels=${grade_levels}`)
                .then(response => { 
                    this.areas = response.data;
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.$parent.isLoading = false;
                });

            if (VueCookies.isKey('ar')) {
                this.selected = VueCookies.get('ar');
            }
        },
        getLabel: function(area) {
            return `${area.name} (${area.state}-${area.year})`;
        },
        store: function() {
            VueCookies.set('ar', this.selected, Infinity);
        },
        clear: function() {
            this.selected = [];
            this.store();
        }
    },

    data() {
        return {
            selected: [],
            areas: []
        }
    }
}
</script>